import { ActionLogRequestPayload } from "@/data/payload/super-admin/action-log-request-payload";
import { ActionLogInfoEntity } from "@/domain/entity/super-admin/action-log-info-entity";
import { SuperAdminRepository } from "@/domain/repository/super-admin-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

/**
 * 특정 환자(스크리닝 ID)의 액션 로그를 한 페이지 조회하는 유즈케이스
 * DEV/QA 환경 전용 화면에서만 사용되며(PROD 제외), 의료기기 소프트웨어 문서(SDS/SUV) 범위에서 제외되는 예외 기능이다.
 */
export class FetchActionLogUsecase {
  constructor(private readonly actionLogRepository: SuperAdminRepository) {}

  async execute(
    screeningId: string,
    pageSize: number,
    currentPage: number
  ): Promise<SATResult<ActionLogInfoEntity, SATError>> {
    const newPayload: ActionLogRequestPayload = {
      screeningId: screeningId,
      pageSize: pageSize,
      currentPage: currentPage,
    };
    const result = await this.actionLogRepository.getActionLog(newPayload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(result.value);
  }
}
